<template>
  <div class="ekg__container d-flex justify-content-center mt-3 mb-3">
    <div v-if="showInputModes" class="ekg__input-modes d-flex flex-grow-1">
      <b-button
        variant="light"
        class="font-weight-bold bg-white border-dark"
        data-test-id="MonitorModeButton"
        @click="setMode(MODES.MONITOR)"
      >
        Monitor Integration
      </b-button>

      <b-button
        variant="light"
        class="font-weight-bold bg-white border-dark"
        data-test-id="PictureModeButton"
        @click="setMode(MODES.PICTURE)"
      >
        Take Picture
      </b-button>
    </div>

    <Camera v-if="mode === MODES.PICTURE" :event-type="eventType" v-on="$listeners" />
    <Monitor v-if="mode === MODES.MONITOR" :monitors="monitors" :form-data="formData" v-on="$listeners" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import Camera from "@/Case/components/Camera.vue";
import Monitor from "@/Case/components/Monitor.vue";

const MODES = {
  UNKNOWN: "",
  PICTURE: "picture",
  MONITOR: "monitor",
};

export default Vue.extend({
  name: "Ekg",

  components: { Camera, Monitor },

  props: {
    eventType: {
      type: String,
      default: "",
    },
    monitors: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      MODES,
      mode: "",
    };
  },

  computed: {
    showInputModes(this: any): Boolean {
      return !!(this.mode === "" && this.monitors.length);
    },
  },

  mounted(): void {
    this.setMode(MODES.UNKNOWN);

    if (!this.monitors.length) {
      this.setMode(MODES.PICTURE);
    }
  },

  methods: {
    setMode(mode): void {
      this.mode = mode;

      const modalTitle = this.getModalTitleByMode(mode);
      const modalTitleStyle = modalTitle.length > 60 ? { "text-align": "center", "font-size": "1.2rem" } : {};

      this.$emit("update-modal", { title: modalTitle, titleStyle: modalTitleStyle });
    },

    getModalTitleByMode(mode: string): string {
      const defaultTitle = "EKG";
      const titleByMode = {
        [MODES.UNKNOWN]: () =>
          this.monitors.length
            ? "Your agency has an active Zoll Monitor integration. Please choose method of EKG capture."
            : defaultTitle,
        [MODES.PICTURE]: () => defaultTitle,
        [MODES.MONITOR]: () => "Select Monitor and Enter Patient ID",
      };
      return (titleByMode[mode] && titleByMode[mode]()) || defaultTitle;
    },
  },
});
</script>

<style lang="scss" scoped>
.ekg__input-modes {
  max-width: 80%;
  justify-content: space-between;

  & .btn {
    flex-basis: 10.8rem;
    white-space: nowrap;
  }
}

@media (max-width: 575px) {
  .ekg__input-modes {
    max-width: 100%;
    justify-content: space-around;

    & .btn {
      flex-basis: 7.8rem;
    }
  }
}
</style>
